'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import FlexGridLayout, { FlexGridItem } from '@/src/layouts/FlexGridLayout';
import Multilingual from '@/src/components/global/Multilingual';
import { client } from '@/sanity/lib/client';
import { submissionSettingsQuery } from '@/sanity/lib/queries';
import { cx } from '@/src/styles/stylebook';
import { ToastModal } from '@/src/components/global/modal/ToastModal';
const inquirySchema = z.object({
  applicant_name: z.string().min(1, '신청자명을 입력해주세요'),
  applicant_contact: z.string().min(1, '연락처를 입력해주세요'),
  applicant_password: z.string().min(1, '비밀번호를 입력해주세요')
});
function StaticSectionFields(t0) {
  const $ = _c(16);
  const {
    section,
    data
  } = t0;
  const t1 = section.key;
  let t2;
  if ($[0] !== section.title) {
    t2 = <h5 className="h5 px-marg pb-2.5"><Multilingual>{section.title}</Multilingual></h5>;
    $[0] = section.title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== section.description) {
    t3 = section.description && <p className="px-marg mb-4 opacity-60">{section.description}</p>;
    $[2] = section.description;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== data || $[5] !== section.fields) {
    let t5;
    if ($[7] !== data) {
      t5 = (field, fieldIndex) => {
        const value = data[field.key];
        if (field.type === "array" && Array.isArray(value)) {
          return <StaticArrayField key={field.key} field={field} value={value} />;
        }
        return <FlexGridLayout key={field.key} className="odd:bg-system-tilebg py-3"><FlexGridItem cols={2} className="h6 max-md:p max-md:w-grid-2 shrink-0 text-pretty"><Multilingual>{field.label}{field.required ? "*" : ""}</Multilingual></FlexGridItem><FlexGridItem cols={10} className="h6 max-md:p max-md:w-grid-4 font-medium! *:w-full max-md:shrink-0">{field.type === "text" ? <div className="input text-gray-70 min-h-[100px] resize-none whitespace-pre-wrap">{value || "-"}</div> : field.type === "radio" ? <div className="flex flex-col flex-wrap gap-4">{(field.options || []).map(opt => <div key={opt.value} className={cx("h6 max-md:p gap-2")}><span className={cx("text-bg-box px-gutter py-2 break-keep select-none", value === opt.value ? "bg-gray-0 text-green-50" : fieldIndex % 2 === 0 ? "bg-gray-100 text-gray-50" : "bg-system-tilebg text-gray-50")}>{opt.label}</span></div>)}</div> : field.type === "checkbox" ? <div className="flex flex-col gap-4">{(field.options || []).map(opt_0 => <div key={opt_0.value} className={cx("h6 max-md:p gap-2")}><span className={cx("text-bg-box px-gutter py-2 break-keep select-none", Array.isArray(value) && value.includes(opt_0.value) ? "bg-gray-0 text-green-50" : fieldIndex % 2 === 0 ? "bg-gray-100 text-gray-50" : "bg-system-tilebg text-gray-50")}>{opt_0.label}</span></div>)}</div> : <div className="input text-gray-70">{field.type === "password" ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : value || "-"}</div>}</FlexGridItem></FlexGridLayout>;
      };
      $[7] = data;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = section.fields.map(t5);
    $[4] = data;
    $[5] = section.fields;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div>{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== section.key || $[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = <div id={t1} className="py-gutter">{t2}{t3}{t5}</div>;
    $[11] = section.key;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function StaticArrayField(t0) {
  const $ = _c(11);
  const {
    field,
    value
  } = t0;
  const label = field.label || "\uD56D\uBAA9";
  let t1;
  if ($[0] !== field.fields) {
    t1 = field.fields || [];
    $[0] = field.fields;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const childFields = t1;
  let t2;
  if ($[2] !== childFields || $[3] !== label || $[4] !== value) {
    let t3;
    if ($[6] !== childFields || $[7] !== label) {
      t3 = (row, idx) => <div key={idx} className=""><div className="px-marg mb-2 flex items-center"><h5 className=""><Multilingual>{label} {idx + 1}</Multilingual></h5></div><div className="grid gap-2">{childFields.map(cf => {
            const fieldValue = row[cf.key];
            return <FlexGridLayout key={cf.key} className="odd:bg-system-tilebg h6 max-md:p py-3"><FlexGridItem cols={2} className="max-md:w-grid-2 shrink-0 text-pretty"><Multilingual>{cf.label}{cf.required ? "*" : ""}</Multilingual></FlexGridItem><FlexGridItem cols={10} className="max-md:w-grid-4 font-medium! *:w-full max-md:shrink-0">{cf.type === "text" ? <div className="input text-gray-70 min-h-[100px] resize-none whitespace-pre-wrap">{fieldValue || "-"}</div> : cf.type === "radio" ? <div className="flex flex-col flex-wrap gap-4">{(cf.options || []).map(opt => <div key={opt.value} className={cx("h6 max-md:p gap-2")}><span className={cx("text-bg-box px-gutter py-2 break-keep select-none", fieldValue === opt.value ? "bg-gray-0 text-green-50" : "bg-system-tilebg text-gray-50")}>{opt.label}</span></div>)}</div> : cf.type === "checkbox" ? <div className="flex flex-col gap-4">{(cf.options || []).map(opt_0 => <div key={opt_0.value} className={cx("h6 max-md:p gap-2")}><span className={cx("text-bg-box px-gutter py-2 break-keep select-none", Array.isArray(fieldValue) && fieldValue.includes(opt_0.value) ? "bg-gray-0 text-green-50" : "bg-system-tilebg text-gray-50")}>{opt_0.label}</span></div>)}</div> : <div className="input text-gray-70">{cf.type === "password" ? "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022" : fieldValue || "-"}</div>}</FlexGridItem></FlexGridLayout>;
          })}</div></div>;
      $[6] = childFields;
      $[7] = label;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = value.map(t3);
    $[2] = childFields;
    $[3] = label;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="flex flex-col gap-3"><div className="flex flex-col gap-4">{t2}</div></div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
export default function InquiryPage() {
  const [view, setView] = useState('form');
  const [submissionList, setSubmissionList] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [formSettings, setFormSettings] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm({
    resolver: zodResolver(inquirySchema)
  });
  const onSubmit = async values => {
    setLoading(true);
    try {
      // First get form settings
      const settings = await client.fetch(submissionSettingsQuery);
      setFormSettings(settings);

      // Then query submission data
      const params = new URLSearchParams({
        applicant_name: values.applicant_name,
        applicant_contact: values.applicant_contact,
        applicant_password: values.applicant_password
      });
      const response = await fetch(`/api/submission?${params}`);
      const result = await response.json();
      if (!result.ok) {
        toast.error(result.error || '조회 실패');
        return;
      }
      setSubmissionList(result.data);
      setView('list');
      toast.success(`${result.data.length}건의 신청을 찾았습니다.`);
    } catch (error) {
      toast.error('조회 중 오류가 발생했습니다.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  const resetToForm = () => {
    setView('form');
    setSubmissionList([]);
    setSelectedSubmission(null);
    setFormSettings(null);
  };
  const backToList = () => {
    setView('list');
    setSelectedSubmission(null);
  };
  const selectSubmission = submission => {
    setSelectedSubmission(submission);
    setView('detail');
  };

  // List view
  if ((view === 'list' || view === 'detail') && submissionList.length > 0) {
    return <>
        <div className="py-gutter max-md:pt-[calc(var(--headerh)+var(--spacing-gutter))]">
          <div className="px-marg mb-2 flex items-center justify-between">
            <h5>신청 목록</h5>
            <button onClick={resetToForm} className="h6 hover:text-green-40 max-md:p underline-offset text-green-50">
              다른 정보로 조회하기
            </button>
          </div>

          <div className="mb-50">
            <p className="text-gray-60 px-marg mb-6">
              <Multilingual>
                총 <span className="word-num">{submissionList.length}</span>건의 신청을 찾았습니다.
                조회하고 싶은 신청을 선택해주세요.
              </Multilingual>
            </p>

            <div className="flex flex-col">
              {submissionList.map((submission_0, idx) => <div key={submission_0._id} onClick={() => selectSubmission(submission_0)} className="hover:bg-gray-5 odd:bg-system-tilebg hover: px-marg py-gutter cursor-pointer pb-4 transition-all">
                  <div className="mb-2 flex items-center justify-between">
                    <h3 className="h5">신청 #{idx + 1}</h3>
                    <span className="text-gray-60 text-sm">
                      {new Date(submission_0.createdAt).toLocaleString('ko-KR')}
                    </span>
                  </div>
                  <p className="text-gray-60 text-sm">클릭하여 상세 내용을 확인하세요</p>
                </div>)}
            </div>
            <div className="p-marg">
              <button onClick={resetToForm} className={cx('text-gray-0 bold h3 disabled:text-gray-70 hover:bg-gray-0 mx-auto flex w-full items-center justify-center rounded-full bg-green-50 px-30 py-4 pb-5 text-center hover:text-green-50', 'max-md:h5 max-md:min-w-[220px]')}>
                다른 정보로 조회하기
              </button>
            </div>
          </div>
        </div>

        <ToastModal isOpen={view === 'detail' && !!selectedSubmission && !!formSettings} handleClose={backToList}>
          {selectedSubmission && formSettings && <div className="pb-20">
              <div className="py-gutter">
                <div className="px-marg">
                  <h5>출품확인</h5>
                  <h5>
                    {selectedSubmission.sections['info_3']?.applicant_name}님의 출품내역이
                    확인되었습니다.
                    <br />
                    <br />
                    관련 문의
                    <br />
                    미쟝센단편영화제 프로그램팀
                    <br />
                    02-6377-0530 /{' '}
                    <a href="mailto:msff.submission@gmail.com" className="text-green-500 underline">
                      msff.submission@gmail.com
                    </a>
                  </h5>
                </div>
                <div className="px-marg text-gray-60 mb-4">
                  제출일시: {new Date(selectedSubmission.createdAt).toLocaleString('ko-KR')}
                </div>
              </div>

              {formSettings.sections.map(section => {
            const sectionData = selectedSubmission.sections[section.key];
            if (!sectionData) return null;
            return <StaticSectionFields key={section.key} section={section} data={sectionData} />;
          })}
            </div>}
        </ToastModal>
      </>;
  }

  // Form view
  return <div className="py-gutter max-md:pt-[calc(var(--headerh)+var(--spacing-gutter))]">
      <div className="px-marg mb-8">
        <h5 className="mb-4">출품확인</h5>
        <p className="text-gray-60">제출하신 신청서를 조회하려면 아래 정보를 입력해주세요.</p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-8">
        <div className="">
          <FlexGridLayout className="odd:bg-system-tilebg py-3">
            <FlexGridItem cols={2} className="h6 max-md:p max-md:w-grid-2 shrink-0 text-pretty">
              <Multilingual>출품자 이름 *</Multilingual>
            </FlexGridItem>
            <FlexGridItem cols={10} className="h6 max-md:p max-md:w-grid-4 font-medium! *:w-full max-md:shrink-0">
              <input className="input" type="text" placeholder="신청자명을 입력해주세요" {...register('applicant_name')} />
              {errors.applicant_name && <span className="smallp text-red-500">{errors.applicant_name.message}</span>}
            </FlexGridItem>
          </FlexGridLayout>

          <FlexGridLayout className="odd:bg-system-tilebg py-3">
            <FlexGridItem cols={2} className="h6 max-md:p max-md:w-grid-2 shrink-0 text-pretty">
              <Multilingual>연락처 *</Multilingual>
            </FlexGridItem>
            <FlexGridItem cols={10} className="h6 max-md:p max-md:w-grid-4 font-medium! *:w-full max-md:shrink-0">
              <input className="input" type="text" placeholder="연락처를 입력해주세요" {...register('applicant_contact')} />
              {errors.applicant_contact && <span className="smallp text-red-500">{errors.applicant_contact.message}</span>}
            </FlexGridItem>
          </FlexGridLayout>

          <FlexGridLayout className="odd:bg-system-tilebg py-3">
            <FlexGridItem cols={2} className="h6 max-md:p max-md:w-grid-2 shrink-0 text-pretty">
              비밀번호*
            </FlexGridItem>
            <FlexGridItem cols={10} className="h6 max-md:p max-md:w-grid-4 font-medium! *:w-full max-md:shrink-0">
              <input className="input" type="password" placeholder="비밀번호를 입력해주세요" {...register('applicant_password')} />
              {errors.applicant_password && <span className="smallp text-red-500">{errors.applicant_password.message}</span>}
            </FlexGridItem>
          </FlexGridLayout>
        </div>

        <div className="px-marg">
          <button type="submit" disabled={loading} className={cx('text-gray-0 bold h3 disabled:text-gray-70 hover:bg-gray-0 mx-auto flex w-full items-center justify-center rounded-full bg-green-50 px-30 py-4 pb-5 text-center hover:text-green-50', 'max-md:h5 max-md:min-w-[220px]')}>
            {loading ? '조회 중...' : '조회하기'}
          </button>
        </div>
      </form>
    </div>;
}